/**
 * Shared strong-password guidance shown in HIBP / leaked-password warnings.
 *
 * These are descriptive patterns rather than verbatim reusable passwords —
 * we don't want users copy-pasting example strings into the password field.
 */

export const STRONG_PASSWORD_EXAMPLES: readonly string[] = [
  "Four unrelated words joined by dashes — e.g. lantern-otter-quiet-river",
  "16+ random characters generated by a password manager (1Password, Bitwarden, iCloud Keychain)",
  "A memorable passphrase only you'd know, mixed with numbers and symbols",
];

export const STRONG_PASSWORD_TIP =
  "Make it unique to Elara Health — never reuse a password from another site.";
